import PrimeBadge from "../../../../../../../components/primeBadge/PrimeBadge";
import TextWrapper from "../../../../../../../components/textWrapper/TextWrapper";
import { defaultProfileImage } from "../../../../../../../constants/defaultUserImage";
import UserAvatar from "../../../../../../../components/userAvatar/UserAvatar";
import styles from "./onePlayer.module.css";

const OnePlayer = ({ player, gameName, onClick, tournamentType = "solo" }) => {
  const isSquad = tournamentType === "squad";

  const squadCaptain =
    player?.members?.find((member) => member?.role === "captain") ||
    player?.members?.[0];
  const squadImage =
    player?.squadImageId?.path || player?.squadImage?.path || null;

  const userGame = player?.gameIds?.find((item) => item.gameName === gameName);

  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.rightSide}>
        <div className={styles.imageWrapper}>
          {isSquad ? (
            <img src={squadImage || defaultProfileImage} alt="squad" />
          ) : (
            <UserAvatar src={player?.userImage?.path} alt="user" />
          )}
        </div>
        <div className={styles.namesWrapper}>
          <div className={styles.nameRow}>
            <TextWrapper textStyle={"textSmall"}>
              {isSquad ? player?.name : player?.name}
            </TextWrapper>
            {!isSquad && (
              <PrimeBadge isPrime={player?.isPrime} primeTier={player?.primeTier} size="small" />
            )}
          </div>
          <div className={styles.uniqueNameWrapper}>
            <TextWrapper textStyle={"textSmall"}>
              {isSquad
                ? `${player?.slug ? `(${player.slug}) ` : ""}${
                    squadCaptain?.userId?.name || ""
                  }`
                : userGame?.inGameName}
            </TextWrapper>
          </div>
        </div>
      </div>
      <div className={styles.leftSide}>
        <TextWrapper textStyle={"textMid"}>
          {isSquad
            ? `${player?.membersCount || player?.members?.length || 0} عضو`
            : userGame?.inGameId}
        </TextWrapper>
      </div>
    </div>
  );
};

export default OnePlayer;
